import { requestCreator, UnknownError } from "../../common/actions/VisitApi";

export const requestToCreateBookmark = requestCreator<number, null, UnknownError>(projectId => ({
  path: "/api/v2/project_bookmarks",
  method: "POST",
  body: {
    project_id: projectId,
  },
}));

export const requestToDeleteBookmark = requestCreator<number, null, UnknownError>(projectId => ({
  path: "/api/v2/project_bookmarks",
  method: "DELETE",
  body: {
    project_id: projectId,
  },
}));



// WEBPACK FOOTER //
// ./frontend/src/project_bookmarks/api/index.ts